export default "__VITE_PUBLIC_ASSET__d1cbd532__"